import React from 'react'
import { Box } from '@mui/material'
import { FooterWrapper } from './StyledComponents'

function Footer() {
	return (
		<FooterWrapper>
			<Box>&copy; 2023-24 Urban Development Department, Govt. of Uttar Pradesh</Box>
			<Box>Powered by UPYOG | Copywrite © 2022 National Institute of Urban Affairs | UPYOG License</Box>
		</FooterWrapper>
	)
}

export default Footer
